module.exports = __webpack_public_path__ + "static/media/undraw_3-d_modeling_h-60-h.e30a68de.svg";